module.exports = __webpack_public_path__ + "static/img/photo-test01.bd91981.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo-test01.jpg
// module id = 7EMZ
// module chunks = 1